import type { Page } from '../../types';

const minStandardDiversityInclusion: Page[] = [
  {
    pageType: 'question',
    title: 'Minimum Standards',
    name: 'minimum-standards',
    hidePageTitle: true,
    description:
      'A conversation must take place at the start of the year between you and your line manager to agree how these standards will be demonstrated in a way that is relevant to your role. You should agree how you will determine whether you have ‘met’ these <a href="https://intranet.cabinetoffice.gov.uk/documents/2180/3717_SCS_Minimum_Standards_AW_3nspT0U.pdf" target="_blank" rel="noopener noreferrer">minimum standards</a>.<br><br>Line Managers will make judgements on whether standards have been met as part of their validation.<br><br>Please complete the box below on how you have met each of the Minimum Standards. Please refer to evidence captured throughout the performance year<br><br>',
    questions: [
      {
        questionType: 'textarea',
        textRows: 20,
        title: 'Diversity & Inclusion',
        name: 'minimum-standard-diverityinclusion',
        detailsHeading: 'More information',
        detailsContent: `The minimum Diversity & Inclusion standards require all SCS to:<br><ul>
  <li>Take a data-driven, evidence-led and delivery-focused approach to Diversity and Inclusion.</li>
  <li>Take personal responsibility delivering <a href="https://intranet.cabinetoffice.gov.uk/information-for-employees/diversity-and-inclusion/diversity-and-inclusion-strategy/" target="_blank" rel="noopener noreferrer">Diversity and Inclusion strategy</a> by embedding D&amp;I considerations in all decision making and delivery.</li>
  <li>Set high expectations of leadership and people management for those with whom they work, and hold others accountable for making good decisions, even when this may prove challenging or unpopular.</li>
</ul>`,
        hint: `How will this be demonstrated in my role?  
  • Take personal responsibility delivering Diversity and Inclusion strategy by embedding D&amp;I considerations in all decision making and delivery.`,
        wordCount: 250,
        rules: {
          required: true,
        },
      },
    ],
  },
];

export default minStandardDiversityInclusion;
